import React, { useState } from "react";
import { Button, DialogTitle } from "@mui/material";
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';


const MuiConfirmationButton = (props) => {
    const [open, setOpen] = useState(false);

    const handleClickOpen = () => {
        setOpen(true);
    };

    const handleClose = () => {
        setOpen(false);
    };

    const confirmPOD = () => {
        setOpen(false);
        props.updateStatusCallback(true);  
    };
    const translatedText = JSON.parse(sessionStorage.getItem("TranslationText"));
    return (
        <React.Fragment>
            <Button
                type={props.type}
                color={props.color}
                variant="contained"
                style={{ display: props.show ? "block" : "none" }}  
                onClick={handleClickOpen}
            >
                {props.text}
            </Button>
            <Dialog
                open={open}
                onClose={handleClose}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
            >
                <DialogTitle>{translatedText.pod_confirmation}</DialogTitle>
                <DialogContent>
                    <DialogContentText id="alert-dialog-description">
                        {translatedText.are_you_sure_you_want_to_confirm_pod}
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button
                        color= "grey"
                        variant="contained"
                        onClick={handleClose}>
                            NO
                    </Button>
                    <Button
                        color="primary"
                        variant="contained"
                        onClick={confirmPOD} autoFocus>
                        YES
                    </Button>
                </DialogActions>
            </Dialog>
        </React.Fragment>
    );
};

export default MuiConfirmationButton;
